import React from "react";
import {useDropzone} from "react-dropzone";
import {styled} from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";

import {COLOR_GREEN, COLOR_LIGHTEST_GREEN, COLOR_WHITE} from "@/themes/colors.jsx";
import ErrorLabel from "@/components/form/ErrorLabel.jsx";

import FileUploadIcon from '@svg/file-upload-19.svg';
import {Flex} from "@/components/typography/index.jsx";


const ResumeDropzone = function ({
                                     file,
                                     onDrop,
                                     onRemove,
                                     error,
                                     loading,
                                     ...props
                                 }) {

    const onDropAccepted = (acceptedFiles) => {
        onDrop(acceptedFiles)
    }

    const {getRootProps, getInputProps, open} = useDropzone({
        onDropAccepted,
        accept: {
            'application/pdf': [],  // Accepts PDF
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': []  // Accepts DOCX
        },
        multiple: false,
    });

    const hasFile = () => {
        return !!file;
    }

    return (
        <Container>
            <DropzoneContainer
                {...getRootProps()}
                haveError={!!error}
                {...props}
            >
                <ResumeButton loading={loading}
                              uploaded={hasFile()}
                              variant="contained"
                              type="button"
                              size="medium">
                    <Flex>
                        <FileUploadIconStyled/>
                        {hasFile() ? (
                            <> <FileName>{file.name}</FileName> <VerticalLine/> <RemoveLink
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onRemove()
                                }}
                            >
                                Remove
                            </RemoveLink></>
                        ) : (
                            <> Attach your resume</>
                        )}
                    </Flex>
                </ResumeButton>

                <Error>{error}</Error>

                <DropzoneInput {...getInputProps()} />
            </DropzoneContainer>
        </Container>
    );
};

export default ResumeDropzone;

const Container = styled('div')({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
});

const DropzoneContainer = styled('div')({
    width: '100%',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    outline: 'none',
    position: 'relative',
});

const FileUploadIconStyled = styled(FileUploadIcon)({
    marginRight: '10px',
});

const FileName = styled('div')({
    maxWidth: '102px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '155px',
    whiteSpace: 'nowrap',
});

const VerticalLine = styled('div')({
    width: '1px',
    height: '24px',
    background: COLOR_WHITE,
    margin: '0 10px',
});

const RemoveLink = styled('div')({
    fontSize: '13px',
    fontWeight: '800',
    lineHeight: '22px',
    color: '#9fc086',
});

const ResumeButton = styled(LoadingButton)(({uploaded}) => ({
    borderColor: COLOR_GREEN + ' !important',
    color: (uploaded ? COLOR_WHITE : COLOR_GREEN) + ' !important',
    background: (uploaded ? COLOR_GREEN : COLOR_LIGHTEST_GREEN) + ' !important',
    borderRadius: '12px',
    fontSize: '17px',
    fontWeight: '600',
    lineHeight: '24px',
    minWidth: '260px',
    paddingTop: '12px',
    paddingBottom: '12px',

    '&:hover': {
        borderColor: COLOR_GREEN,
        background: COLOR_GREEN,
        color: COLOR_WHITE,
        boxShadow: 'none',
    },
}));

const DropzoneInput = styled('input')({
    width: '100%',
    aspectRatio: '1',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    outline: 'none',
});

const Error = styled(ErrorLabel)({
    position: 'absolute',
    top: '-15px',
    zIndex: 10,
    margin: 0,
    width: '100%',
    textAlign: 'left',
});





